import { useEffect, useState } from 'react';
import Reporting from "../../../global/Reporting";
import { checkEdoPermissionsAcrossPrograms } from '../../../../libs/edoPermissions';
import userAccountSignal from '../../../../signals/UserAccount.signal';
import api from '../../../../api/api';
import loaderSignal from '../../../../signals/Loader.signal';
import BreadCrumbWrapper from 'components/global/BreadCrumbs/BreadCrumbs';

const EdoReporting = () => {
  const [canRunReports, setCanRunReports] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkRunReportsPermission = async () => {
      try {
        setIsChecking(true);
        loaderSignal.update({ isContentLoading: true });
        const userData = userAccountSignal.value.userData;
        
        // Wait for userData to be loaded
        if (!userData) {
          setIsChecking(false);
          loaderSignal.reset();
          return;
        }

        // Fetch funding programs for the EDO
        const fundingPrograms = await api.get({
          path: '/fundingPrograms',
          options: {
            where: {
              edoId: userData?.account.edoId,
            },
          },
        });

        const permissions = await checkEdoPermissionsAcrossPrograms(
          fundingPrograms,
          ['canRunReports']
        );
        setCanRunReports(permissions.canRunReports);
      } catch (error) {
        console.error('Error checking run reports permission:', error);
        setCanRunReports(false);
      } finally {
        setIsChecking(false);
        loaderSignal.reset();
      }
    };

    checkRunReportsPermission();
  }, [userAccountSignal.value.userData]);

  if (isChecking) {
    return (
      <BreadCrumbWrapper>
        <div className="bg-white p-32 border border-gray shadow-sm">
          <p className="text-center">Loading...</p>
        </div>
      </BreadCrumbWrapper>
    );
  }

  if (!canRunReports) {
    return (
      <BreadCrumbWrapper>
        <div className="bg-white p-32 border border-gray shadow-sm">
          <h3 className="text-center">Access Denied</h3>
          <p className="text-center">
            You do not have permission to run reports.
          </p>
        </div>
      </BreadCrumbWrapper>
    );
  }

  return <Reporting />;
};

export default EdoReporting;